import { Injectable } from '@angular/core';
import { Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpAuthService } from '@shared/service/http-auth.service';
import { Appointments2 } from '../models/appointments.model';
import { Appointment2Model } from '../models/appointment.model';
import { Utilities } from '@shared/utilities/utilities.model';
import { AppointmentStatsItemModel } from '../models/appointment-stats-item.model';
import { ListService } from '@shared/models/list-service.model';
import { Appointments2File, Appointments2FilterModel } from '../models/appointments2-filter.model';
import { CcDkAppointmentStatsFilterModel } from '@cc-dekra/models/cc-dk-appointment-stats-filter.model';
import { AppConfigEnvironment } from '@shared/models/appconfig-environment.model';
import { AppConfigEnvironmentService } from '@shared/service/appconfig-environment.service';
import { OrderDriver } from 'app/delivery/models/order-driver';

@Injectable()
export class Appointments2Service implements ListService {

	environment: AppConfigEnvironment;
	appointment: Appointment2Model;
	constructor(private httpAuthService: HttpAuthService,
		private appConfig: AppConfigEnvironmentService) {
		this.environment = appConfig.Environment;
	}

	getList(filter?: Appointments2FilterModel): Observable<Appointments2> {
		let url: string = this.environment.APPOINTMENTS2 + '/appointments';
		if (Utilities.isVoid(filter.status)) {
			filter.status = '' + Appointment2Model.STATUS_PLANNED + ',' + Appointment2Model.STATUS_PENDING + ',' + Appointment2Model.STATUS_PLANNING
				+ ',' + Appointment2Model.STATUS_PLANNING_HIDDEN + ',' + Appointment2Model.STATUS_CLOSED + ',' + Appointment2Model.STATUS_EXPIRED;
		}

		if (filter) {
			url += filter.getFilterUrl().replace(/\+/g, '%2B');
		}
		// veniva impostato 'asc' 2 volte
        /*const asc = filter.asc;
		if (!Utilities.isVoid(filter.asc)) {
			url += ('&asc=' + (asc ? 0 : 1));
		}*/

		const options = new RequestOptions();
		return new Observable<Appointments2>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.status === 200) {
							try {
								observer.next(new Appointments2(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	getAppointmentByOrderId(orderId: string, exclude_expired?: boolean, include_closed?: boolean): Observable<Appointment2Model> {
		let url: string = this.environment.APPOINTMENTS2 + '/appointments';
		const filter: Appointments2FilterModel = new Appointments2FilterModel();
		filter.ald_order_id = orderId;
		if (exclude_expired) {
			filter.status = [Appointment2Model.STATUS_PLANNING, Appointment2Model.STATUS_PLANNED, Appointment2Model.STATUS_PENDING];
			if (include_closed) {
				filter.status.push(Appointment2Model.STATUS_CLOSED);
			}
		}
		if (filter) {
			url += filter.getFilterUrl().replace(/\+/g, '%2B');
		}
		const options = new RequestOptions();
		return new Observable<Appointment2Model>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.status === 200) {
							try {
								const appointment = response.json().items[0];
								if (!Utilities.isVoid(appointment)) {
									observer.next(new Appointment2Model(response.json().items[0]));
								} else {
									observer.next(null);
								}
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	getOrderDriver(orderId: string): Observable<OrderDriver> {
		let url: string = this.environment.GW_API + '/orderDriver/' + orderId;
		const options = new RequestOptions();
		return new Observable<OrderDriver>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.status === 200) {
							try {
								const orderDriver = response.json().items[0];
								if (!Utilities.isVoid(orderDriver)) {
									observer.next(new OrderDriver(response.json().items[0]));
								} else {
									observer.next(null);
								}
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}
	
	getAppointmentByID(appointmentID: any): Observable<Appointment2Model> {
		const url: string = this.environment.APPOINTMENTS2 + '/appointments/' + appointmentID;
		const options = new RequestOptions();
		return new Observable<Appointment2Model>(
			observer => {
				this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
					response => {
						if (response.status === 200) {
							try {
								observer.next(new Appointment2Model(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					});
			});
	}

	getStats(filter: CcDkAppointmentStatsFilterModel): Observable<Map<string, AppointmentStatsItemModel>> {
		let url: string = this.environment.APPOINTMENTS2 + '/appointments/stats';
		if (filter) {
			url = url + filter.getFilterUrl().replace(/\+/g, '%2B');
		}
		return new Observable<Map<string, AppointmentStatsItemModel>>(observer => {
			this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, null).subscribe(resp => {
				if (!Utilities.isVoid(resp) && resp.status === 200) {
					const model = resp.json();
					if (!Utilities.isVoid(model)) {
						const stats = new Map<string, AppointmentStatsItemModel>();
						for (const d of Object.keys(model.stats)) {
							const date = model.stats[d];
							if (Utilities.isVoid(filter) || Utilities.isVoid(filter.granularity)) {
								stats.set(d, model.stats[d] as AppointmentStatsItemModel);
							} else if (filter.granularity === 'place') {
								for (const key of Object.keys(date)) {
									stats.set(key, date[key] as AppointmentStatsItemModel);
								}
							}
						}
						observer.next(stats);
					} else {
						observer.error('body; ' + model);
					}
				} else {
					observer.error('response; ' + resp);
				}
			}, error => {
				observer.error(error);
			});
		});
	}


	newAppointment(body: Appointment2Model): Observable<Response> {
		const url: string = this.environment.APPOINTMENTS2 + '/appointments';
		return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, null);
	}

	createFile(body: Appointments2File): Observable<Response> {
		const url: string = this.environment.APPOINTMENTS2 + '/appointments/file';
		const options = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('Content-Type', 'application/json');
		return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options);
	}

	updateAppointment(appointmentId: string, body: Appointment2Model): Observable<Response> {
		const url: string = this.environment.APPOINTMENTS2 + '/appointments/' + appointmentId + '/confirmandupdate';
		const options = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('Content-Type', 'application/json');

		return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options);
	}

	updateFieldsOfAppointment(appointmentId: string, body: any): Observable<Response> {
		const url: string = this.environment.APPOINTMENTS2 + '/appointments/' + appointmentId;
		const options = new RequestOptions();
		options.headers = new Headers();
		options.headers.set('Content-Type', 'application/json');

		return this.httpAuthService.patch(url, body, this.environment.ROOT_REDIRECT, options);
	}
}

